import React from "react";

const Star = ({size = 30, fill = '#FDB022', isHalf = false}) => {

    if (!isHalf)
        return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 30 30"
                    fill="none">
            <g clip-path="url(#clip0_5217_1574)">
                <path
                    d="M14.3075 2.41495C14.5637 1.79898 15.4363 1.79898 15.6925 2.41495L18.7916 9.86616C18.8996 10.1258
                19.1438 10.3033 19.4242 10.3257L27.4684 10.9706C28.1334 11.024 28.403 11.8538 27.8964 12.2878L21.7675
                 17.5378C21.5539 17.7208 21.4607 18.0079 21.5259 18.2815L23.3984 26.1312C23.5532 26.7802 22.8472 27.2931 22.2779 26.9453L15.3909 22.7388C15.1509 22.5922 14.8491 22.5922 14.6091 22.7388L7.72209 26.9453C7.15276 27.2931 6.44682 26.7802 6.60162 26.1312L8.47408 18.2815C8.53933 18.0079 8.44605 17.7208 8.23246 17.5378L2.10362 12.2878C1.59697 11.8538 1.86661 11.024 2.5316 10.9706L10.5758 10.3257C10.8562 10.3033 11.1004 10.1258 11.2084 9.86616L14.3075 2.41495Z"
                    fill={fill}/>
            </g>
            <defs>
                <clipPath id="clip0_5217_1574">
                    <rect width="30" height="30" fill="white"/>
                </clipPath>
            </defs>
        </svg>;
    else
        return <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_5454_1417)">
                <path
                    d="M8.58451 1.44892C8.73822 1.07934 9.26178 1.07934 9.41549 1.44892L11.275 5.91965C11.3398 6.07546 11.4863 6.18191 11.6545 6.1954L16.481 6.58234C16.88 6.61433 17.0418 7.11225 16.7378 7.37265L13.0605 10.5227C12.9324 10.6324 12.8764 10.8047 12.9156 10.9688L14.039 15.6787C14.1319 16.0681 13.7083 16.3758 13.3667 16.1671L9.23456 13.6432C9.09056 13.5553 8.90944 13.5553 8.76544 13.6432L4.63325 16.1671C4.29166 16.3758 3.8681 16.0681 3.96097 15.6787L5.08445 10.9688C5.1236 10.8047 5.06763 10.6324 4.93948 10.5227L1.26217 7.37265C0.95818 7.11225 1.11997 6.61433 1.51896 6.58234L6.34549 6.1954C6.5137 6.18191 6.66022 6.07546 6.72502 5.91965L8.58451 1.44892Z"
                    fill="#EAECF0"/>
                <g clip-path="url(#clip1_5454_1417)">
                    <path
                        d="M8.58451 1.44892C8.73822 1.07934 9.26178 1.07934 9.41549 1.44892L11.275 5.91965C11.3398 6.07546 11.4863 6.18191 11.6545 6.1954L16.481 6.58234C16.88 6.61433 17.0418 7.11225 16.7378 7.37265L13.0605 10.5227C12.9324 10.6324 12.8764 10.8047 12.9156 10.9688L14.039 15.6787C14.1319 16.0681 13.7083 16.3758 13.3667 16.1671L9.23456 13.6432C9.09056 13.5553 8.90944 13.5553 8.76544 13.6432L4.63325 16.1671C4.29166 16.3758 3.8681 16.0681 3.96097 15.6787L5.08445 10.9688C5.1236 10.8047 5.06763 10.6324 4.93948 10.5227L1.26217 7.37265C0.95818 7.11225 1.11997 6.61433 1.51896 6.58234L6.34549 6.1954C6.5137 6.18191 6.66022 6.07546 6.72502 5.91965L8.58451 1.44892Z"
                        fill={fill}/>
                </g>
            </g>
            <defs>
                <clipPath id="clip0_5454_1417">
                    <rect width="18" height="18" fill="white"/>
                </clipPath>
                <clipPath id="clip1_5454_1417">
                    <rect width="9" height="18" fill="white"/>
                </clipPath>
            </defs>
        </svg>


}

export default Star;